{
	"page": {
		"title": "Card Handover Locations",
		"intro": "Where accreditation cards are handed over — the Accreditation Centre and the welcome desks at airports, land crossings and ferry terminals.",
		"add": "Add location",
		"count_one": "{{n}} location",
		"count_other": "{{n}} locations"
	},
	"filters": {
		"searchPlaceholder": "Name, code or address",
		"statusChips": "Status"
	},
	"sort": {
		"order": "Display order",
		"codeAsc": "Code A–Z"
	},
	"table": {
		"location": "Location",
		"codeAndAddress": "{{code}} · {{address}}",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"order": "Order",
		"created": "Created",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} location",
		"summary_other": "{{from}}–{{to}} of {{total}} locations",
		"empty": "No locations"
	},
	"empty": {
		"filteredTitle": "No locations match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No handover locations yet",
		"noneDescription": "Add the Accreditation Centre and the welcome desks where cards change hands.",
		"clearFilters": "Clear filters"
	},
	"stats": {
		"total": "Locations",
		"active": "Active",
		"inactive": "Inactive"
	},
	"form": {
		"addTitle": "Add handover location",
		"addDescription": "Staff pick it when they record who handed a card to whom.",
		"addSubmit": "Add location",
		"saveChanges": "Save changes",
		"field": {
			"name": "Name",
			"nameHint": "As staff know it — KLIA Terminal 1.",
			"code": "Code",
			"codeHint": "Short, unique — KUL T1.",
			"address": "Address",
			"addressHint": "Where the desk is, so a courier can find it.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Pickers list by this.",
			"active": "Active",
			"activeHint": "Inactive locations stay on past handovers but can't be picked."
		},
		"placeholder": {
			"name": "KLIA Terminal 1",
			"code": "KUL T1",
			"address": "Arrival Hall, Door 3, Kuala Lumpur International Airport"
		}
	},
	"delete": {
		"title": "Delete handover location",
		"description": "Delete <strong>{{name}}</strong>? If handovers already name it, deactivate it instead.",
		"confirm": "Delete location",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete location",
		"inUse": "Handovers already name this location. Deactivate it instead."
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add location",
		"updateFailed": "Couldn't update location"
	},
	"errors": {
		"codeTaken": "A location with that code already exists.",
		"nameTaken": "A location with that name already exists.",
		"invalidValue": "Invalid value"
	}
}
